import { Injectable } from '@angular/core';

import { HttpClientService } from '../common/http-client.service';

@Injectable({
  providedIn: 'root',
})
export class SpamTitanService {
  private url = 'spam_titan';

  constructor(private httpClient: HttpClientService) {}

  create(contactId: number, listType: string, params: any): Promise<any> {
    params.contact_id = contactId;
    params.list_type = listType;
    return this.httpClient.post(`${this.url}.json`, params);
  }

  createBlacklist(contactId: number, params: any): Promise<any> {
    params.preference = 'blacklist_from';
    return this.create(contactId, 'black', params);
  }

  createWhitelist(contactId: number, params: any): Promise<any> {
    return this.create(contactId, 'white', params);
  }

  delete(contactId: number, listType: string, params: any): Promise<any> {
    return this.httpClient.delete(`${this.url}/${contactId}.json?angular=1&contact_id=${contactId}&list_type=${listType}&value=${params.value}`);
  }

  deleteBlacklist(contactId: number, params: any): Promise<any> {
    return this.delete(contactId, 'black', params);
  }

  deleteWhitelist(contactId: number, params: any): Promise<any> {
    return this.delete(contactId, 'white', params);
  }

  bulkDelete(contactId: number, listType: string, values: string[]): Promise<any> {
    return this.httpClient.delete(`${this.url}/bulk_destroy.json?contact_id=${contactId}&list_type=${listType}&values=${encodeURIComponent(JSON.stringify(values))}`);
  }

  bulkDeleteBlacklist(contactId: number, values: string[]): Promise<any> {
    return this.bulkDelete(contactId, 'black', values);
  }

  bulkDeleteWhitelist(contactId: number, values: string[]): Promise<any> {
    return this.bulkDelete(contactId, 'white', values);
  }

  index(contactId: number, listType: string): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, { angular: 1, contact_id: contactId, list_type: listType });
  }

  indexBlacklist(contactId: number): Promise<any> {
    return this.index(contactId, 'black');
  }

  indexWhitelist(contactId: number): Promise<any> {
    return this.index(contactId, 'white');
  }
}
